// extracted by mini-css-extract-plugin
module.exports = {"footer":"FuwgFooter_footer__7SDeP","text":"FuwgFooter_text__1Vz50"};